import React from 'react';
import 'components/Greeting.scss';
import PropTypes from 'prop-types';

const Greeting = ({ dataItems, currentStepName }) => {
  const title = dataItems[currentStepName].greeting;
  const subTitle = dataItems[currentStepName].paragraph;

  return (
    (title || subTitle) && (
      <div
        className={
          'w-full flex flex-col items-center justify-center text-center mb-6 md:!mb-10 px-2'
        }
      >
        {title && (
          <h3
            className="text-main text-base md:text-2xl"
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        )}

        {subTitle && (
          <p className="text-xs italic max-w-[650px] md:text-sm">{subTitle}</p>
        )}
      </div>
    )
  );
};

Greeting.propTypes = {
  dataItems: PropTypes.object.isRequired,
  currentStepName: PropTypes.string.isRequired,
  moduleData: PropTypes.object,
  step: PropTypes.number,
};
export default Greeting;
